<template>
  <div>
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.network.steam.step3.title`) }}
    </p>
    <VTableHistory
      :items="getHistory"
    />
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import VTableHistory from '@/components/shared/content-views/VTableHistory';

export default {
    name: 'History',
    components: {
        VTableHistory,
    },
    props: {
        history: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
        ]),
        getHistory() {
            return this.history.map(h => ({
                date: this.$options.filters.formatDate(h.updatedAt),
                name: `${h.updatedBy.user.profile.firstName} ${h.updatedBy.user.profile.lastName}`,
                action: this.$t(`forms.labels.${h.action.toLowerCase()}`),
            }));
        },
    },
    watch: {
        history: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.history) };
            },
            immediate: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.yPadding {
  padding: 5px 0 5px 10px;
}

@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
}
.history {
    border: 1px solid #BDC2D0;
    margin: 0 6rem;
}
</style>
